import script from "./DistrictForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DistrictForm.vue?vue&type=script&setup=true&lang=js"

import "./DistrictForm.vue?vue&type=style&index=0&id=d7fc1e04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7fc1e04"]])

export default __exports__